module.exports = __webpack_public_path__ + "img/05-images-pc-m.d2e0ea23.png";